<template>

  <div class="key" :class="[{ active: isActive || isCapslocked, marker: marked, correct: isCorrect }, value.class]">
  	<span>{{ displayValue }}</span>
  </div>

</template>

<script>

const SHIFT_CODE = 16
const CAPSLOCK_CODE = 20
const ALT_CODE = 18
const ALT_CODE_GR = 225

export default {

  name: 'KeyboardKey',

  props: {
  	value: { type: Object, required: true },
  },

  data() {

    return {
    	isActive: false,
    	isCorrect: false,
    	capsLock: false,
    	shifted: false,
    	alted: false,
    	marked: false,
    }
  },

  computed: {

  	isShifted() {
  		if (this.value.shifted) {
  			if (this.shifted || this.capsLock) {
  				if (this.shifted && this.capsLock && this.isLetter) {
  					return false
  				}
  				if (!this.shifted && this.capsLock && !this.isLetter) {
  					return false
  				}
  				return true
  			}
  		}
  		return false
  	},

  	displayValue() {

  		if (this.isShifted) {
  			return this.value.shifted
  		}
  		if (this.alted && this.value.alted) {
  			return this.value.alted
  		}
  		return this.value.char
  	},

  	isLetter() {
  		return this.value.char.length == 1 && this.value.char.match(/[a-z]/i)
  	},

  	isCapslocked() {
  		return this.value.keyCode == CAPSLOCK_CODE && this.capsLock
  	},

  },

  methods: {
		
		handleKeyDown(e) {
			if (e.keyCode == this.value.keyCode) {
				this.isActive = true
				if (this.nextChar == this.value.char || (this.nextChar == ' ' && this.value.char == 'Space')) {
					this.isCorrect = true
				}
			}

			if (e.keyCode == SHIFT_CODE) {
				this.shifted = true
			}

			if (e.keyCode == ALT_CODE_GR) {
				this.alted = true
			}

			/* this check the initial setting preventing opposite state */
			this.capsLock = e.getModifierState('CapsLock')

			if (e.keyCode == CAPSLOCK_CODE) {
				this.capsLock = !this.capsLock
			}
		},

		handleKeyUp(e) {
			if (e.keyCode == this.value.keyCode) {
				this.isActive = false
			}

			if (e.keyCode == SHIFT_CODE) {
				this.shifted = false
			}

			if (e.keyCode == ALT_CODE_GR) {
				this.alted = false
			}

			this.isCorrect = false
		},

		handleNextChar(char) {
			this.nextChar = char
			if (char == this.value.char || (char == ' ' && this.value.char == 'Space')) {
				this.marked = true
			} else {
				this.marked = false
			}
		},

		handleFinished() {
			this.isActive = false
		},
  },

  mounted() {

  	this.$bus.on( 'app:keydown', this.handleKeyDown )
  	this.$bus.on( 'app:keyup', this.handleKeyUp )
  	this.$bus.on( 'app:next-char', this.handleNextChar)
  	this.$bus.on( 'app:finished', this.handleFinished)
  },
}
</script>

<style lang="css" scoped>
.key {
    background-color: rgb(243, 243, 243);
    border: 2px solid #424242;
    border-radius: 5px;
    grid-column: span 2;
    font-size: 20px;
    text-align: center;
    padding-top: 17px;
}

.key span.shifted, .key span.alted {
    display: none;
}

.key.active {
  background-color: #e7a5c4 !important;
  border: 3px solid #424242;
}

.key.active.correct {
	background-color: #b4e3b1 !important;
  border: 3px solid #424242;	
}

.key.marker {
  background-color: #d2d4f3;
}

.key.double {
  padding-top: 5px;
}

.delete {
    grid-column: span 4;
}

.tab {
    grid-column: span 3;
}

.backslash {
    grid-column: span 3;
}

.capslock {
    grid-column: span 4;
}

.return {
    grid-column: span 3;
}

.leftshift {
    grid-column: span 4;
}

.rightshift {
    grid-column: span 4;
}

.leftctrl {
    grid-column: span 3;
}

.command {
    grid-column: span 3;
    font-size: 14px;
}

.space {
    grid-column: span 21;
}
</style>